"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var AbstractValueAccessor_1 = require("@utils/AbstractValueAccessor");
var DatePickerComponent = /** @class */ (function (_super) {
    __extends(DatePickerComponent, _super);
    function DatePickerComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.placeholder = '';
        _this.time = false;
        _this.name = '';
        _this.disabled = false;
        _this.range = false;
        _this.pick = new core_1.EventEmitter();
        return _this;
    }
    Object.defineProperty(DatePickerComponent.prototype, "dateFormat", {
        get: function () {
            return this.time ? 'Y-m-d H:i:S' : 'Y-m-d';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePickerComponent.prototype, "altFormat", {
        get: function () {
            return this.time ? 'd. m. Y H:i' : 'd. m. Y';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePickerComponent.prototype, "mode", {
        get: function () {
            return this.range ? 'range' : 'single';
        },
        enumerable: true,
        configurable: true
    });
    return DatePickerComponent;
}(AbstractValueAccessor_1.AbstractValueAccessor));
exports.DatePickerComponent = DatePickerComponent;
